'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const PaymentBvrAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 84 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "rect",
        {
          x: 0.5,
          y: 0.5,
          width: 83,
          height: 57,
          rx: 3.5,
          fill: "#FAD6D7",
          stroke: "#E1E0DF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M35.0367 25.81H55.4748V27.26H35.0367V25.81ZM35.0367 30.16H77.8593V31.61H35.0367V30.16ZM77.8593 34.51H35.0367V35.96H77.8593V34.51Z",
          fill: "#D17272"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M31.1437 3.3988H32.592V4.35001H44.7691V5.80001H32.592V7.25001H49.6353V8.70001H32.592V10.15H41.8494V11.6H32.592V13.05H41.8494V14.5H32.592V17.0404H64.2339V14.5H63.0058V13.05H64.2339V10.15H63.0058V8.70001H64.2339V5.80001H63.0058V4.35001H64.2339V3.3988H65.6822V4.35001H83.4439V5.80001H65.6822V8.70001H75.6579V10.15H65.6822V13.05H71.765V14.5H65.6822V17.0404H80.779V18.4904H32.592V24.65H55.7644V26.1H32.592V43.5H35.4886V44.95H32.592V47.2468H31.1437V44.95V43.5V26.1V24.65V18.4904V17.0404V14.5V13.05V11.6V10.15V8.70001V7.25001V5.80001V4.35001V3.3988Z",
          fill: "#666666"
        }
      ),
      /* @__PURE__ */ jsx("rect", { x: 2.89655, y: 30.45, width: 24.6207, height: 4.35, fill: "white" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M79.6552 10.15C79.6552 6.94672 77.0615 4.34998 73.8621 4.34998C70.6626 4.34998 68.069 6.94672 68.069 10.15C68.069 13.3532 70.6626 15.95 73.8621 15.95C77.0615 15.95 79.6552 13.3532 79.6552 10.15ZM69.0345 10.15C69.0345 7.4806 71.1959 5.31664 73.8621 5.31664C76.5283 5.31664 78.6897 7.4806 78.6897 10.15C78.6897 12.8194 76.5283 14.9833 73.8621 14.9833C71.1959 14.9833 69.0345 12.8194 69.0345 10.15Z",
          fill: "#D17272"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M1.44827 49.3H82.5517V53.55C82.5517 55.2068 81.2086 56.55 79.5517 56.55H4.44827C2.79141 56.55 1.44827 55.2068 1.44827 53.55V49.3Z",
          fill: "white"
        }
      )
    ]
  }
);
const VpPaymentBvrAsset = forwardRef(PaymentBvrAsset);

export { VpPaymentBvrAsset as default };
